import { getCurRegion } from './multiRegionUtil';

export const REGION = getCurRegion();
export const IS_ID = getCurRegion() === 'ID'; // Indonesia
export const IS_MY = getCurRegion() === 'MY'; // Malaysia
export const IS_TH = getCurRegion() === 'TH'; // Thailand
export const IS_PH = getCurRegion() === 'PH'; // Philipine
export const IS_VN = getCurRegion() === 'VN'; // Vietnam
export const IS_TW = getCurRegion() === 'TW'; // Taiwan
export const IS_SG = getCurRegion() === 'SG'; // Singapore

const SUPPORT_REDIRECT_SHOPEE_APP = IS_TH;
const TH_UNIVERSAL_LINK = 'https://shopee.co.th/shp_app_link';

export { SUPPORT_REDIRECT_SHOPEE_APP, TH_UNIVERSAL_LINK };
export default null;